import { provideAuthInitializer } from '@yoshu-lib/core/auth/auth-initializer.factory'

import { provideAubertduvalAuthService } from './config/auth-service.provider'
import { provideAubertduvalAuthStore } from './config/auth-store.provider'
import { provideEnvironment } from './config/environment.provider'

export const provideCore = () => [
  provideEnvironment(),
  provideAuthInitializer(),
  provideAubertduvalAuthService(),
  provideAubertduvalAuthStore()
]
